import { toHref } from '@core/external-links/models';
import { getExtLinkEnv } from '@core/external-links/redux';
import { myMembershipAccount } from '@core/links/account';
import { useReduxState } from '@engage/redux/hooks';

export const useUpgradeFromFreePath = (trackingParams?: {
  source: string;
  sourceDetail?: string;
}) => {
  const linkEnv = useReduxState(getExtLinkEnv);
  let linkWithTrackingParams = toHref(myMembershipAccount, linkEnv);

  if (trackingParams) {
    const { source, sourceDetail } = trackingParams;
    const encodedSourceParam = `source=${encodeURIComponent(source)}`;
    const encodedSourceDetailParam =
      sourceDetail && `sourceDetail=${encodeURIComponent(sourceDetail)}`;

    linkWithTrackingParams = linkWithTrackingParams + '?' + encodedSourceParam;
    if (encodedSourceDetailParam) {
      linkWithTrackingParams = linkWithTrackingParams + '&' + encodedSourceDetailParam;
    }
  }

  return linkWithTrackingParams;
};
